import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { Companies } from 'app/models/companies';
// import { Companies } from '../models/Companies';


@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  constructor(
    private http: HttpClient,
  ) { }

  getAll(data: any, page: any, perPage?: any): Observable<object> {
    page = page ? page : 1;
    perPage = perPage ? perPage : 10;
    return this.http.post<object>(`${environment.yiiUrl}companies/search?page=` + page +
    '&expand=type_data,contacts,agency_data&auction=true&index=true&per-page=' + perPage, data, { observe: 'response' as 'body' })
      .pipe(map(companies => {
        return companies;
      }));
  }
  getById(_id: string): Observable<object> {
    return this.http.get(`${environment.yiiUrl}companies/${_id}?expand=linked_users_data`, {});
  }

  getContactsDatabyId(_id: string): Observable<object> {
    return this.http.get(`${environment.yiiUrl}companies/${_id}?expand=contacts,accounts_contacts`);
  }

  create(company: Companies): Observable<object> {
    return this.http.post(`${environment.yiiUrl}companies`, company);
  }

  update(company: Companies): Observable<object> {
    return this.http.put(`${environment.yiiUrl}companies/${company._id}`, company);
  }

  delete(_id: number): Observable<object> {
    return this.http.delete(`${environment.yiiUrl}companies/${_id}`);
  }

  searchAgencies(page: any, data: any): Observable<Companies[]> {
    return this.http.post<Companies[]>(`${environment.yiiUrl}companies/search?page=` + page, data, { observe: 'response' as 'body' })
      .pipe(map(companies => {
        return companies;
      }));
  }

  createContact(contact: any): Observable<object> {
    return this.http.post(`${environment.yiiUrl}contacts`, contact);
  }

  updateContact(contact: any): Observable<object> {
    return this.http.put(`${environment.yiiUrl}contacts/${contact._id}`, contact);
  }

  deleteContact(_id: string, createdby: string, agencyid: string): Observable<object> {
    return this.http.delete(`${environment.yiiUrl}contacts/${_id}?created_by=${createdby}&agency=${agencyid}`);
  }

  downloadCSV(filter: any): Observable<object> {
    return this.http.post(`${environment.apiUrl}companies/download-csv`, filter);
  }
  downloadTimelineCSV(data: any): Observable<object> {
    data = { ...data, model: 'Company' };
    return this.http.post(`${environment.yiiUrl}xml-export-formats/export-timeline-csv`, data);
  }

  importCSV(files: any, id: string): Observable<object> {
    return this.http.post(`${environment.yiiUrl}xml-export-formats/csv-company-uploader?user=${id}`, files);
  }

  downloadContactsCSV(_id: string): Observable<object> {
    const filter = {
      id: _id
    };
    return this.http.post(`${environment.apiUrl}companies/download-contacts-csv`, filter);
  }

  uploadLogo(_id: string, file: any): Observable<object> {
    const formData: any = new FormData();
    formData.append('id', _id);
    formData.append('file', file);
    formData.append('model', 'companies');
    return this.http.post(`${environment.yiiUrl}users/upload-single`, formData);
  }

  getArchiveCompanies(filter: any, page?: any, perPage?: any): Observable<any> {
    page = page ? page : 1;
    perPage = perPage ? perPage : 10;
    return this.http.post<any>(`${environment.yiiUrl}companies/deleted-companies?page=${page}&per-page=${perPage}`, filter, { observe: 'response' as 'body'});
  }

  restoreArchiveCompany(_id: number, data: any): Observable<object> {
    return this.http.put(`${environment.yiiUrl}companies/${_id}`, data);
  }

  deleteArchiveCompany(_id: number, createdby: any, agency: any): Observable<object> {
    return this.http.delete(`${environment.yiiUrl}companies/${_id}?created_by=${createdby}&agency=${agency}`);
  }

  restoreSelectedCompanies(filter: any): Observable<any> {
    return this.http.post<any>(`${environment.yiiUrl}companies/restore-selected`, filter);
  }

  deleteSeletedArchiveCompanies(filter: any): Observable<object> {
    return this.http.post(`${environment.yiiUrl}companies/delete-selection`, filter);
  }

  restoreAll(agency: any): Observable<object> {
    return this.http.get(`${environment.yiiUrl}companies/restore-all?agency=${agency}`);
  }

  deleteAll(agency: any): Observable<object> {
    return this.http.delete(`${environment.yiiUrl}companies/delete-all?agency=${agency}`);
  }
}

